import React from 'react';
import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';
import moment from 'moment';
import Modal from '@roo/roo/Modal';

import * as API from '../api';
import pageJump from '../utils/pageJump';

interface LooseObject {
    [key: string]: any;
}

/**
 * 费率 2.0 【统一换签】弹窗
 * PRD：https://km.sankuai.com/page/608036967
 * 接口：https://km.sankuai.com/page/679419983
 *
 * 弹框场景
 * - 统一换签弹框：每天最多提示1次（设备+门店维度）
 */
const freeChangeUnifiedRemaind = () => {
    const CACHE_KEY = 'FEE_CHANGE_UNIFIED_RENEWAL_REMIND';
    const cacheInfoStr = getStorage(CACHE_KEY) || '{}';
    let cacheInfo: LooseObject = {};
    try {
        cacheInfo = JSON.parse(cacheInfoStr);
    } catch (e) {
        //
    }
    const wmPoiId = Ids.getWmPoiId();

    if (wmPoiId && wmPoiId !== '-1') {
        /**
         *lastShowNotificationDay: 最后展示统一换签提醒的日期
         */
        const poiInfo = cacheInfo[wmPoiId] || {};

        if (poiInfo.lastShowNotificationDay !== moment().format('YYYYMMDD')) {
            // 今天没有展示过
            API.getSignChangesign().then(res => {
                if (res.isRemind) {
                    Modal.confirm({
                        title: res.title,
                        children: (
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: res.content.replace(
                                        /(\d\d\d\d年\d\d?月\d\d?日)/g,
                                        '<b>$1</b>',
                                    ),
                                }}
                            />
                        ),
                        confirmText: '精细化计费切换',
                        cancelText: '取消',
                        onConfirm: () => {
                            pageJump.go('/new_fe/business#/shop/manage/ratePlanExplanation');
                        },
                    });
                    poiInfo.lastShowNotificationDay = moment().format('YYYYMMDD');
                    cacheInfo[wmPoiId] = poiInfo;
                    setStorage(CACHE_KEY, JSON.stringify(cacheInfo));
                }
            });
        }
    }
};

export default freeChangeUnifiedRemaind;
